import { BrandingStyle } from "@bcm-dev/bcms-vite";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function IconToggle
 * @param {STRING} className - Allows us to pass a unique class to each IconToggle. 
 * @param {STRING} icon - Allows us to set the icon id for the SVGAsset.
 * @param {STRING} text - Allows us to set the link text.
 * @param {STRING} data-point - Allows us to set a data-point to the text
 * @returns {React.Component}
 * @example
 * <FormContainer className="some-class">
 *  <FormRowView/>
 * </FormContainer>
 */
export default function IconToggle(props) {
  const className = props.className ?? "";
  const icon = props.icon ?? "";
  const text = props.text ?? "";
  const dataPoint = props.dataPoint ?? "";
  
  // "props.isActive" is currently used in page "E-Statements & Notices" 
  // for showing/hiding content but not through an accordion toggle.
  // This "Search" link with the icon is needed but not for an accordion toggle, 
  // but for toggling other content.
  const propsIsActive = props.isActive ?? false;
  const [ active, setActive ] = useState(propsIsActive);
  const onClick = evt => {
    setActive(!active);
    if(props.onClick) props.onClick(!active);
  };

  useEffect(() => setActive(propsIsActive), [ propsIsActive ]);

  return (
      <div className={`${className} icon-toggle flex-container flex-horizontal align-top`} onClick={ onClick }>
      <div className="set-width">
        <BrandingStyle style={{"fill" : "links_abi22"}} element={  <SVGAsset id={icon} />} />
      </div>
      <div className="set-width">
      <BrandingStyle  style={{"color" : "links_abi22"}}>
        <span data-point={dataPoint}>{text}</span>
      </BrandingStyle>
      </div>
    </div>                 
  );
}